import { LOCALES, KEYS } from '../constants';

const ptBRTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_PORTUGUESE_BR] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Função do parceiro",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Integrador",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Fornecedor",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Nível de parceiro",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Especialização do parceiro",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:"Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Nome do parceiro",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Localização",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"País",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Palavra-chave do nome de parceiro",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Palavras-chave do nome de parceiro",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Classificação",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Especializações",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Especializações do parceiro",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Nível do provedor e Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"provedor gold",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"provedor premier",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"provedor selecionado",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Obtenha orientação",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Solicitar um orçamento",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"Aberto",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Expandir",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Fechar",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Escolher país/região",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Escolha uma função",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Escolher as especializações",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Escolher os Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Escolher especializações",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Escolher níveis",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"País/região do parceiro",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Níveis do integrador",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Níveis do provedor",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Especializações do integrador",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Nomes de parceiros",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Voltar",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Todos os resultados",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Tudo ",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Economia",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"Meus parceiros",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Adicionar",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Remover",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Adicionar para comparar ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Selecionar pelo menos mais uma",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Comparar selecionados ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Remover do comparador",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Comparar",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Nível de parceiro",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Processamento em andamento",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"resultado",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"resultados",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Nenhum resultado",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"resultam em",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"resulta em",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Nenhum resultado em",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Anterior",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Anterior",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Avançar",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Salvar",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Conhecimento",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Visão geral",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"é Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Os integradores criam soluções completas para nossos clientes. Eles realizam principalmente transações de revenda, mas trazem seus próprios conhecimentos exclusivos para resolver problemas de negócios dos clientes",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Os provedores são especialistas no fornecimento de soluções gerenciadas e em nuvem. Os clientes estão procurando mais flexibilidade na forma como consomem soluções, e os provedores estão se tornando cada vez mais essenciais no mercado.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Pesquisas anteriores",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Pesquisa anterior",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Funções",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Tecnologia",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Setores",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Integradores",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Provedores",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Outro",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Outros",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Nenhum outro parceiro salvo",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Nenhum integrador salvo",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Nenhum provedor salvo",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"filtrar por necessidade",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"pesquisar por critérios combinados",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"pesquisar por local",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Há 1 parceiro atendendo em todo o mundo",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Há",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"parceiros atendendo em todo o mundo",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Não há parceiros atendendo",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"Há 1 parceiro atendendo em",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"parceiros atendendo em",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Não há parceiros atendendo em",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Alterar local",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Filtrar por necessidade",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Pesquisar",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"por nome, nível e especialização",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"selecionado",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Nenhuma correspondência encontrada",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Classificar",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Classificar para baixo",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Nome ascendente",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Nome descendente",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Login obrigatório",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Você deve fazer login para executar esta ação",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Falha na restauração da pesquisa",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Fazer login",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Parceiro salvo com sucesso",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"Não foi possível salvar o parceiro",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Parceiro removido com sucesso",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"Não foi possível excluir o parceiro",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Digite uma palavra-chave para pesquisar por nome, nível ou especialização",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Os desenvolvedores são especialistas que criam soluções personalizadas de software e hardware de acordo com a tecnologia da Cisco, resultando em soluções exclusivas que ligam sistemas para oferecer resultados.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Os consultores são especialistas com profundo conhecimento do setor, que orientam as empresas à medida que exploram soluções para desafios empresariais complexos.​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Parceiro diversificado",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Em ordem alfabética",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"A maioria dos especialistas",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Desenvolvedor",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Consultor",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtros",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtro",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Conhecimento do parceiro",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Dispensar",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Especialização",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Conhecimentos",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Nenhuma descrição fornecida.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Acerca de",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Limpar comparador",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Comparação de parceiros",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Função",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Foco tecnológico",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Descrição",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Escolher seleção de idioma",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Terminar sessão",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Parceiro inclusivo",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Sobre a Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Fale conosco",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Carreiras",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Conheça nossos parceiros",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Comentários",
    [KEYS.L18N_KEY_LABEL_HELP]: "Ajuda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Termos e Condições",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Declaração de privacidade",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marcas registradas",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparência da cadeia de suprimentos",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa do site",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Sobre a Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Fale conosco",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Carreiras",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Conheça nossos parceiros",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Comentários",
    [KEYS.L18N_KEY_LABEL_HELP]: "Ajuda",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Termos e Condições",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Declaração de privacidade",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Marcas registradas",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Transparência da cadeia de suprimentos",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa do site",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Como comprar",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Parceiros",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Produtos e Serviços",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Soluções",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Suporte",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Aprender",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Explorar Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menu",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Fechar",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Ver mais",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Ver menos",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Não tem uma conta?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "inscreva-se"
  }
});

export default ptBRTranslations;
